import React from 'react';

export default function FitnessProfilePrimaryBadge({ className = '' }) {
	return (
		<span
			className={`inline-flex shrink-0 items-center gap-1 rounded-full border border-yellow-200 bg-yellow-50 px-2.5 py-0.5 text-xs font-semibold tracking-tight text-yellow-800 dark:border-yellow-700 dark:bg-dark-bg dark:text-yellow-300 ${className}`}
		>
			<i className="fa-solid fa-star text-xs text-yellow-600 dark:text-yellow-400" aria-hidden="true" />
			Primary
		</span>
	);
}
